<template>
<div >
  <!-- style="position:fixed;top:40px;margin-left:auto;margin-right:auto;z-index:100000;width:460px;" -->
  <v-alert value="true" type="warning" dismissible
    class="pa-2"
    color="error"
    v-if='isReadOnly === true' >Account is not active. It is in read-only mode
    <v-btn small flat @click="showmore=true" >More info</v-btn>
    <v-btn :href='billingUrl' target='_blank' color="primary" >Reactivate account
      <v-icon small class='ml-2' >open_in_new</v-icon>
    </v-btn>
  </v-alert>

  <v-dialog  xs12 dense
    type='error' width="460"
    v-model='showmore' >
    <v-card>
      <v-card-title class="grey lighten-4 py-1" >
        Account is in read-only mode
        <v-spacer/>
        <v-btn @click="showmore=false" small icon ><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text >
        <div v-text="text" class="mb-3" />
        <center>
        <v-btn flat text
          href='mailto:support@appointmentguru.co' target='_blank' >
          Contact support
          <v-icon small class='ml-2' >open_in_new</v-icon>
        </v-btn>
        <v-btn flat text style='float:right;' target='_blank'
          href='https://appointmentguru.co/help/why-am-i-seeing-an-upgrade-notice' >
          Why am I seeing this
          <v-icon small class='ml-2' >open_in_new</v-icon>
        </v-btn>
        </center>
      </v-card-text>
      <v-divider/>
      <v-card-actions >

        <v-spacer />
        <v-btn :href='billingUrl' target='_blank' color="primary" >Reactivate account
          <v-icon small class='ml-2' >open_in_new</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  name: 'ReadOnlyBlock',
  props: {
    text: {
      type: String,
      default: 'This account is in read-only mode because either your free trial has expired or your most recent payment has failed.<br/> This means you\'ll be able to view your data but you won\'t be able to create new appointments. To resolve this issue either click on Upgrade or contact Support.'
    }
  },
  data () { return {showmore: false} },
  computed: {
    ...mapGetters(['isReadOnly'])
    // billingToken () {
    //   if (this.$store.getters.me && this.$store.getters.me.channel) {
    //     return this.$store.getters.me.channel.replace('practitioner-', '')
    //   }
    // }
    // billingUrl () {
    //   if (this.billingToken) {
    //     return `https://subscriptionguru.appointmentguru.co/pay/5/?t=${this.billingToken}`
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// ReadOnlyBlock.vue?d46eb8e4